import ApiFactory from '@ers/api/ApiFactory';
import { isStatusOK } from '@ers/helpers/api/ResponseProcessors';
import AppApi from '@ers/root/App.api';
import { useState } from 'react';


const getApi = () => {
    const apiFactory = new ApiFactory();
    const api = apiFactory.create();
    const appApi = new AppApi(api);
    return appApi;
};
const useOfferLinkService = () => {
    const api = getApi();
    const [isLoading, setIsLoading] = useState(false);
    const trySave = ({ applicationId, url }, successCb) => {
        setIsLoading(true);
        return api.addJobOfferLink(applicationId, url).then((response) => {
            setIsLoading(false);
            if (isStatusOK(response)) {
                successCb(response.data);
                return true;
            }
            return false;
        }).catch(() => false);
    };
    return { isLoading, trySave };
};

export default useOfferLinkService;